import R from 'ramda';
import { isProductMatchedByFilters } from './get-filtered-products';

export const getAllVariants = R.chain(R.propOr([], 'variants'));

export default ({
  products = [],
  selectedFilters = [],
  categories = [],
}) => (
  products.reduce((state, product) => {
    if (!R.isNil(product) && R.has('variants', product)) {
      const productWithFilteredVariants = R.evolve({
        variants: R.filter(({ filterCategories: productCategories }) =>
          isProductMatchedByFilters({ selectedFilters, categories, productCategories })),
      }, product);

      if (productWithFilteredVariants.variants.length > 0) {
        state.push(productWithFilteredVariants);
      }
    }

    return state;
  }, [])
);
